import { createAction } from '@reduxjs/toolkit'
import prefix from 'modules/utils/prefix'
import { ISetPermissionsPayload } from './models'

const namespaced = prefix('settings')

export const SET_PERMISSIONS = namespaced('setPermissions')
export const setPermissions = createAction<ISetPermissionsPayload>(SET_PERMISSIONS)
